import { useSelector } from 'react-redux';
import { selectDelivery } from '@store/order/selectors';
import PacketaScript from '@pages/order/payment-shipping/dispatch-scripts/PacketaScript';
import DpdScript from '@pages/order/payment-shipping/dispatch-scripts/DpdScript';



const Dispatch = (): JSX.Element => {

	const zasilkovnaId = process.env.ZASILKOVNA_ID ? parseInt(process.env.ZASILKOVNA_ID) : 0;
	const dpdId = process.env.DPD_ID ? parseInt(process.env.DPD_ID) : 0;
	
	const delivery = useSelector(selectDelivery);


	if (!delivery) return (
		<></>
	)

	if (delivery.id !== zasilkovnaId && delivery.id !== dpdId) return (
		<></>
	)

	return (
		<div className='dispatch-point-section'>

			{delivery.id === zasilkovnaId &&
				<PacketaScript />}

			{delivery.id === dpdId &&
				<DpdScript />}

		</div>
	);
};

export default Dispatch;